import { getIntroCopy, getLeadPopLocale } from './introCopy.js';

const intro = getIntroCopy(getLeadPopLocale());

export const FALLBACK_LITERALS = Object.freeze({
    'hud.score': 'Puntos',
    'hud.time': 'Tiempo',
    'hud.lives': 'Vidas',
    'hud.livesAria': '%1$s vidas',
    'hud.soundOn': 'Sonido activado',
    'hud.soundOff': 'Sonido desactivado',
    'hud.soundToggle': 'Activar o desactivar sonido',
    'hud.good': 'Leads',
    'game.title': 'Lead Pop',
    'game.subtitle': 'Toca oportunidades, evita ruido',
    'game.hint': 'Toca las gestiones y evita SPAM, meetings urgentes y otras distracciones.',
    'game.intro.title': intro['game.intro.title'],
    'game.intro.subtitle': intro['game.intro.subtitle'],
    'game.intro.go': intro['game.intro.go'],
    'game.paused': 'Pausado',
    'game.soundHint': 'Activa el sonido para más emoción',
    'result.finished': 'Prospección completada',
    'result.died': 'Fin de la partida',
    'result.skipped': 'Partida omitida',
    'result.score': 'Puntuación',
    'result.goodHits': 'Leads captados',
    'result.badHits': 'Errores',
    'result.copy': 'Copiar resultado',
    'result.copying': 'Copiando…',
    'result.copiedImage': 'Imagen copiada',
    'result.copiedText': 'Texto copiado',
    'result.copyError': 'No se pudo copiar',
    'result.restart': 'Jugar otra vez',
    'items.hot': 'Lead caliente',
    'items.backendLead': 'Lead',
    'items.bonusName': 'Bonus',
    'items.bonus': 'Racha comercial',
    'activities.phoneCall': 'Llamadas telefónicas',
    'activities.checkIn': 'Check-in',
    'activities.videoCheckIn': 'Video Check-in',
    'activities.fastCheckIn': 'Fast Check-in',
    'activities.email': 'Email',
    'activities.videoCall': 'Video llamada',
    'activities.whatsapp': 'Whatsapp',
    'badItems.spam': 'SPAM',
    'badItems.spam.subtitle': 'Bandeja a reventar',
    'badItems.urgentMeeting': 'Meeting urgente',
    'badItems.urgentMeeting.subtitle': '¿Tienes 5 minutos?',
    'badItems.ghostClient': 'Cliente fantasma',
    'badItems.ghostClient.subtitle': 'Lee y no responde',
    'badItems.infiniteExcel': 'Excel infinito',
    'badItems.infiniteExcel.subtitle': 'Solo una columna más',
    'badItems.massCc': 'CC masivo',
    'badItems.massCc.subtitle': '47 personas en copia',
    'badItems.surpriseMeeting': 'Reunión imprevista',
    'badItems.surpriseMeeting.subtitle': '¿De qué hablamos?',
    'badItems.zombieLead': 'Lead zombie',
    'badItems.zombieLead.subtitle': '¿Sigues interesado?',
    'badItems.coldCoffee': 'Café frío',
    'badItems.coldCoffee.subtitle': 'La máquina otra vez',
    'badItems.duplicate': 'Duplicado',
    'badItems.duplicate.subtitle': 'Ya lo tenemos',
});
